import { Component, HostListener } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DriverRecordRequestService } from '../../../services/driverrecordrequest.service';
import { GeneralService } from '../../../services/general.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { IWizard } from '../../../interfaces/iwizard';
import { WizardSteps } from '../../../interfaces/wizard-steps';
import { ActivatedRoute, Router } from '@angular/router';
import { DateTime } from 'luxon';
import { UserProfile } from 'src/app/interfaces/UserProfile';

@Component({
    selector: 'app-review',
    templateUrl: './review.component.html',
    styleUrls: ['./review.component.scss'],
    standalone: false
})
export class ReviewComponent {

     form!: FormGroup;
     public wizard!: IWizard;
     userProfile?: UserProfile;

     dateOfBirthDisplay: string = '';
     continueButtonText: string = '';
     backButtonText: string = '';
     isLoading: boolean = false;

     constructor (public service: DriverRecordRequestService,
          public generalService: GeneralService,
          public authenticationService: AuthenticationService,
          public _router: Router, private route: ActivatedRoute) {
          this.wizard = this.service.getWizard();
     }

     ngOnInit(): void {
          setTimeout(() => this.scrollToTop(), 500);
          this.userProfile = this.authenticationService.getUserProfile();

          if (this.service.isDriverRequestInitialized === false && this.service.loadFromLocal() === false) {
               this._router.navigateByUrl('/driver/1');
          }

          // Handle null on first load, setting to false. 
          //   Don't set to false if user has already agreed and is navigating back through the wizard. 
          if (this.service.driverRequest.driverHasConsented !== true && this.service.driverRequest.driverHasConsented + '' !== 'true') {
               this.service.driverRequest.driverHasConsented = false;
          }

          if (this.service.driverRequest.dateOfBirth) {
               const month = Number(this.service.driverRequest.dateOfBirth.toString().substring(5, 7));
               const day = Number(this.service.driverRequest.dateOfBirth.toString().substring(8, 10));
               const year = Number(this.service.driverRequest.dateOfBirth.toString().substring(0, 4));
               var theDate = DateTime.fromObject({ year: year, month: month, day: day, hour: 12, minute: 0 });
               this.dateOfBirthDisplay = theDate.toFormat('MM/dd/yyyy');
          }

          if (this.service.justSubscribe){
               this.continueButtonText = this.doTranslation('Subscribe');
          } else {
               this.continueButtonText = this.doTranslation('Continue');
          }

          if (this.service.isReorder()) {
               this.backButtonText = this.doTranslation('Edit');
          } else {
               this.backButtonText = this.doTranslation('Back');
          }
     }

     moveNext() {
          this.isLoading = true;
          const next = this.service.continueLinkRoute(7);
          if (next === '/driver/subscribed'){
               const monitoringPromise = this.service.enrollInMonitoring();
               this.generalService.pageLogging('/driver/8', null, '', '', 'Enrolled in monitoring without Lexis Nexis quiz for email ' + this.service.driverRequest.emailAddress);
               monitoringPromise.then((result: any) => this.navigateToNext(result));
          } else {
               this._router.navigateByUrl(next);
          }
     }

     navigateToNext(redirectUrl: string | any) {
          if (redirectUrl.startsWith('/')) {
               this._router.navigateByUrl(redirectUrl);
          } else {
               window.location = redirectUrl;
          }
     }

     doTranslation(translationTag: string): string {
          let translatedText: string = this.generalService.getTranslation(translationTag, 'base');
          if (translatedText === undefined) {
               translatedText = this.generalService.getTranslation(translationTag, 'base');
          }
          return translatedText;
     }

     scrollToTop() {
          window.scrollTo(0, 0);
     }

     ngOnDestroy() {
          this.service.saveToLocal();
     }

     pageValid(): boolean {
          return this.service.driverRequest.driverHasConsented.toString() === 'true';
     }

     @HostListener('window:beforeunload', ['$event'])
     unloadMessage($event: { returnValue: string; }) {
          return $event.returnValue = 'Your changes will not be saved';
     }
}
